/***
 * Created on 2023/8/17
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useQuery} from "@tanstack/react-query";

export const useCaptcha = (inputChangeHandler) => {
    const { t } = useTranslation();
    const [hasCaptcha, setHasCaptcha] = useState(null);
    const [captchaValue, setCaptchaValue] = useState("");
    const inputRef = useRef();
    const isDirty = useRef(false);
    const [captchaError, setCaptchaError] = useState("");

    const {data, isSuccess} = useQuery({
        queryKey: ['get_captcha_image'],
        queryFn: async () => {
            const response = await fetch('/captcha');
            const blob = await response.blob();
            return blob;
        }
    });

    const onInputChange = (e) => {
        inputRef.current.setAttribute('required', true);
        isDirty.current = true;
        setCaptchaValue(e.target.value);

        if (isDirty.current && !inputRef?.current?.checkValidity()) {
            setCaptchaError(t('@Required@'));
        }
        else {
            setCaptchaError("");
        }

        if (typeof inputChangeHandler === 'function') {
            inputChangeHandler(e);
        }
    }

     useEffect(() => {
        if (isSuccess && data) {
            if (data.type.match('image')) {
                const imageObjectUrl = URL.createObjectURL(data);
                setHasCaptcha(imageObjectUrl);
            }
            else {
                setHasCaptcha(null);
            }
        }
    }, [isSuccess, data]);

    const Captcha = (
        <div className="dialog__form-group">
            <label>{t('@Type the characters you see in the picture below.@')}</label>
            <div className="comp-add-ons">
                <div className="captcha">
                    <div className="captcha__img">
                        <img src={hasCaptcha} className="w-full" alt="" />
                    </div>
                    <div className="comp-input captcha__input">
                        <div className="input-field--hybrid">
                            <input
                                type="text"
                                name="captcha"
                                onChange={onInputChange}
                                value={captchaValue}
                                className={`${isDirty.current && !inputRef?.current?.checkValidity() ? "input--invalid" : ""}`}
                                placeholder={t('@Enter@')}
                                ref={inputRef}/>
                            <button className="q-btn q-btn-default">{t('@reload@')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return {Captcha, hasCaptcha, captchaValue, captchaError};
}
